export default __webpack_public_path__ + "static/media/calendar-gray.6898dbac.svg";